


import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function SANGE_Establishment() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('SANGE_Establishment_pdf')}
    title="PDF Document"
  />
</div>

  );
};

export default SANGE_Establishment;
